export default function SMissedCall({ size = 20, className = "", ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path d="M28.4091 6L15.2724 19.1367L8.44328 12.3325H14.8999V7.36583H1.40597e-05V22.2657H4.96664V15.8091L11.7957 22.6134L15.2724 26.09L31.8857 9.47664L28.4091 6Z" fill="currentColor"/>
        </svg>
    )
}